(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('temp-sector', {
            parent: 'entity',
            url: '/temp-sector?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tempSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-sector/temp-sectors.html',
                    controller: 'TempSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempSector');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('temp-sector-detail', {
            parent: 'entity',
            url: '/temp-sector/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tempSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-sector/temp-sector-detail.html',
                    controller: 'TempSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempSector');
                    $translatePartialLoader.addPart('status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TempSector', function($stateParams, TempSector) {
                    return TempSector.get({id : $stateParams.id});
                }]
            }
        })
        .state('temp-sector.new', {
            parent: 'temp-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-sector/temp-sector-dialog.html',
                    controller: 'TempSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                brick: null,
                                osfeBrick: null,
                                phone: null,
                                phone2: null,
                                countryName: null,
                                regionName: null,
                                prefectureName: null,
                                cityName: null,
                                postalCode: null,
                                address: null,
                                addressNum: null,
                                status: null,
                                issuedDate: null,
                                issuedBy: null,
                                autoapprove: null,
                                vat: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('temp-sector', null, { reload: true });
                }, function() {
                    $state.go('temp-sector');
                });
            }]
        })
        .state('temp-sector.edit', {
            parent: 'temp-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-sector/temp-sector-dialog.html',
                    controller: 'TempSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TempSector', function(TempSector) {
                            return TempSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('temp-sector.delete', {
            parent: 'temp-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-sector/temp-sector-delete-dialog.html',
                    controller: 'TempSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TempSector', function(TempSector) {
                            return TempSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
